import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { ListTonesDtoImpl, ListTonesDto } from '../../../../core/dto/listtones/listtonesdto';
import { ListTonesResponse } from '../../../../core/api/mytunes/listtones/listtonesresponse';
import { ListTonesRequestImpl } from '../../../../core/api/mytunes/listtones/listtonesrequest';
import { Strings } from '../../../../utils/resources/strings';
import { DeleteDedicationDtooImpl } from '../../../../core/dto/deletededication/deletededicationdto';
import { DeleteDedicationResponse } from '../../../../core/api/mytunes/deletededication/deletededicationresponse';
import { DeleteDedicationRequestImpl } from '../../../../core/api/mytunes/deletededication/deletededicationrequest';
import { DeleteFromShuffleDtoImpl } from '../../../../core/dto/deletefromshuffle/deletefromshuffledto';
import { DeleteFromShuffleResponse } from '../../../../core/api/mytunes/deletefromshuffle/deletefromshuffleresponse';
import { DeleteFromShuffleRequestImpl } from '../../../../core/api/mytunes/deletefromshuffle/deletefromshufflerequest';
import {  ShuffleDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/shuffle/shufflesdto';
import { ShuffleResponse } from 'src/com/sixdee/crbtportal/core/api/shuffle/shuffleresponse';
import { ShuffleRequestImpl } from 'src/com/sixdee/crbtportal/core/api/shuffle/shufflerequest';

export interface ListToneAPIModel extends APIModel
{
    deleteTone(toneDto: ListTonesDto): void;
    getListofCurrentlyPlaylingTunes(): void;
    shuffleActivateAndDeactivate(identifier: String): void;
}

export class ListToneAPIModelImpl extends APIModelImpl implements ListToneAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }


    shuffleActivateAndDeactivate(identifier: string):void{
        let shuffleData = new ShuffleDtoImpl();
        shuffleData.setLanguage(this.getContext().getUserContext().getLanguage());
        shuffleData.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        shuffleData.setIdentifier(identifier);

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getShuffleAPIProcessor()
        .success((shuffleResponse: ShuffleResponse)=>
        {
            this.getAPIModelHandler().onSuccess(shuffleResponse.getAPIFeature(), 
            shuffleResponse.getDescription(), shuffleData);
          
         })
        .failure((shuffleResponse: ShuffleResponse)=>
         {
           this.getAPIModelHandler().onFailure(shuffleResponse.getAPIFeature(), 
           shuffleResponse.getDescription(), shuffleData);
         })
        .execute(new ShuffleRequestImpl(shuffleData));
     
    }
    deleteTone(toneDto: ListTonesDto): void
    {
       /*  this.getAPIModelHandler().onSuccess("", 
        "", toneDto); */
       
       
        console.log(toneDto.getId());
        if(toneDto.getCaller() === this.getContext().getResources().getString(Strings.all))
        {
            console.log("--tigerall: " + toneDto.getRepeats());
            let deleteFromShuffleDto = new DeleteFromShuffleDtoImpl();
            deleteFromShuffleDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteFromShuffleDto.setToneIdList(toneDto.getId());
            deleteFromShuffleDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteFromShuffleDto.setPriority("0");
            deleteFromShuffleDto.setChannelId(this.getContext().getUserContext().getChannelId());

            if(toneDto.getTime() === this.getContext().getResources().getString(Strings.full_day) &&
            toneDto.getRepeats().length === 0)
            {
                deleteFromShuffleDto.setActivityId("3");
                deleteFromShuffleDto.setServiceId("1");
                deleteFromShuffleDto.setTimeType("");
            }
            else
            {
                deleteFromShuffleDto.setActivityId("3");
                deleteFromShuffleDto.setServiceId("17");
                deleteFromShuffleDto.setTimeType(toneDto.getTimeType());
            }
            this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
            .getDeleteFromShuffleAPIProcessor()
            .success((deleteFromShuffleResponse: DeleteFromShuffleResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteFromShuffleResponse.getAPIFeature(), 
                deleteFromShuffleResponse.getDescription(), toneDto);
              
             })
            .failure((deleteFromShuffleResponse: DeleteFromShuffleResponse)=>
             {
               this.getAPIModelHandler().onFailure(deleteFromShuffleResponse.getAPIFeature(), 
               deleteFromShuffleResponse.getDescription(), undefined);
             })
            .execute(new DeleteFromShuffleRequestImpl(deleteFromShuffleDto));
        }

        else 
        {
            console.log("--tigerspecial");

            let deleteDedicationDto = new DeleteDedicationDtooImpl();
            deleteDedicationDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteDedicationDto.setBPartyMsisdn(toneDto.getCaller());
            deleteDedicationDto.setToneId(toneDto.getId());
            deleteDedicationDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteDedicationDto.setTimeType(toneDto.getTimeType());
   
            this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
            .getDeleteDedicationAPIProcessor()
            .success((deletededicationResponse: DeleteDedicationResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deletededicationResponse.getAPIFeature(), 
                deletededicationResponse.getDescription(), toneDto);
              
             })
            .failure((deleteDedicationResponse: DeleteDedicationResponse)=>
             {
               this.getAPIModelHandler().onFailure(deleteDedicationResponse.getAPIFeature(), 
               deleteDedicationResponse.getDescription(), undefined);
             })
            .execute(new DeleteDedicationRequestImpl(deleteDedicationDto));
        }
       
    }

    getListofCurrentlyPlaylingTunes(): void 
    {
        console.log("---------currentplayiglist");
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("0");
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesForCurrentlyPlayingTunesAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), listTonesResponse.getListTonesResponseDtos());
         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/listtoneapimodel.ts